import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ListBiomarkerResponseElement,
  ListBodySystemResponseElement,
  Food,
  Tag
} from '../types/apiGeneratedTypes';

export interface AppPageState {
  bodySystemsList: ListBodySystemResponseElement[];
  biomarkersList: ListBiomarkerResponseElement[];
  bodySystemToEdit: ListBodySystemResponseElement | null;
  biomarkerToEdit: ListBiomarkerResponseElement | null;
  isUpdateBodySystemModalOpened: boolean;
  isUpdateBiomarkerModalOpened: boolean;
  isDeleteBiomarkerModalOpened: boolean;
  isDeleteBodySystemModalOpened: boolean;
  bodySystemsTableKey: number;
  biomarkersTableKey: number;
  bsCount: number;
  biomarkersCount: number;
  foodList: Food[];
  foodListOptions: { key: any; value: any }[];
  foodsCount: number;
  notesCount: number;
  tagsList: Tag[];
  tagsCount: number;
}

export const initialState: AppPageState = {
  bodySystemsList: [],
  biomarkersList: [],
  bodySystemToEdit: null,
  biomarkerToEdit: null,
  isUpdateBodySystemModalOpened: false,
  isUpdateBiomarkerModalOpened: false,
  isDeleteBiomarkerModalOpened: false,
  isDeleteBodySystemModalOpened: false,
  bodySystemsTableKey: 0,
  biomarkersTableKey: 0,
  bsCount: 0,
  biomarkersCount: 0,
  foodList: [],
  foodListOptions: [],
  foodsCount: 0,
  notesCount: 0,
  tagsList: [],
  tagsCount: 0
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setBiomarkersList(
      state,
      action: PayloadAction<ListBiomarkerResponseElement[]>
    ) {
      state.biomarkersList = action.payload;
    },
    setBodySystemsList(
      state,
      action: PayloadAction<ListBodySystemResponseElement[]>
    ) {
      state.bodySystemsList = action.payload;
    },
    setBiomarkerToEdit(
      state,
      action: PayloadAction<ListBiomarkerResponseElement | null>
    ) {
      state.biomarkerToEdit = action.payload;
    },
    setBodySystemToEdit(
      state,
      action: PayloadAction<ListBodySystemResponseElement | null>
    ) {
      state.bodySystemToEdit = action.payload;
    },
    changeUpdateBiomarkerModalVisibility(
      state,
      action: PayloadAction<boolean>
    ) {
      state.isUpdateBiomarkerModalOpened = action.payload;
    },
    changeDeleteBiomarkerModalVisibility(
      state,
      action: PayloadAction<boolean>
    ) {
      state.isDeleteBiomarkerModalOpened = action.payload;
    },
    changeDeleteBodySystemModalVisibility(
      state,
      action: PayloadAction<boolean>
    ) {
      state.isDeleteBodySystemModalOpened = action.payload;
    },
    changeUpdateBodySystemModalVisibility(
      state,
      action: PayloadAction<boolean>
    ) {
      state.isUpdateBodySystemModalOpened = action.payload;
    },
    setBiomarkersTableKey(state, action: PayloadAction<number>) {
      state.biomarkersTableKey = action.payload;
    },
    setBodySystemsTableKey(state, action: PayloadAction<number>) {
      state.bodySystemsTableKey = action.payload;
    },
    setBsCount(state, action: PayloadAction<number>) {
      state.bsCount = action.payload;
    },
    setBiomarkersCount(state, action: PayloadAction<number>) {
      state.biomarkersCount = action.payload;
    },
    setFoodList(state, action: PayloadAction<Food[]>) {
      state.foodList = action.payload;
    },
    setFoodsCount(state, action: PayloadAction<number>) {
      state.foodsCount = action.payload;
    },
    setFoodOptions(state, action: PayloadAction<Food[]>) {
      state.foodListOptions = action.payload.map((food) => ({
        key: food.id,
        value: food.name
      }));
    },
    setNotesCount(state, action: PayloadAction<number>) {
      state.notesCount = action.payload;
    },
    setTagsList(state, action: PayloadAction<Tag[]>) {
      state.tagsList = action.payload;
      state.tagsCount = action.payload.length;
    },
  }
});

export const {
  setBiomarkersList,
  setBodySystemsList,
  setBiomarkerToEdit,
  setBodySystemToEdit,
  changeUpdateBiomarkerModalVisibility,
  changeUpdateBodySystemModalVisibility,
  changeDeleteBiomarkerModalVisibility,
  setBiomarkersTableKey,
  setBodySystemsTableKey,
  setBsCount,
  changeDeleteBodySystemModalVisibility,
  setBiomarkersCount,
  setFoodList,
  setFoodOptions,
  setFoodsCount,
  setNotesCount,
  setTagsList,
} = appSlice.actions;
export default appSlice.reducer;
